import { UPDATE_ATTRIBUTE } from "../../constants/reduxActionTypes";

const initialState = {
  eventIdExists: false,
  isAuthenticated: false
};
function generalReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_ATTRIBUTE: {
      return Object.assign({}, state, action.payload);
    }

    default:
      return state;
  }
}
export default generalReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/generalReducer.js